module.exports = __webpack_public_path__ + "img/w.fcc00f6f.jpg";